import { render, staticRenderFns } from "./LinkDigiProductModal.vue?vue&type=template&id=303c4578"
import script from "./LinkDigiProductModal.vue?vue&type=script&lang=js"
export * from "./LinkDigiProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports